import * as React from 'react'
import {connect} from 'react-redux'
import {Col, Container, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import {ApplicationState} from "src/store";
import {
    ConfiguratorProduct,
    ProductFamilyIconsInner,
    Product,
    UsedMainCategoriesInner
} from "src/services/api";
import {WithTranslation, withTranslation} from "react-i18next";
import {
    getSelectedAlternatives,
    getSelectedMainCategoryData,
    getSelectedProductData,
    getSelectedSubCategoryData,
    SelectedAlternativeProduct,
    submitConfiguration
} from "App/services";
import {ContactType, CurrencyProps} from "App/constants";
import {Basket} from "App/basket";
import {ContactData, contactFormReady} from "App/contactData";
import StickyBox from "react-sticky-box";
import {ContactOverviewPage} from "Components/ContactOverview";
import {ContactDetailPage} from "Components/ContactDetail";
import {UserState} from "App/user";
import {AsyncButton} from "Components/AsyncButton";

interface StateToProps extends CurrencyProps {
    category: UsedMainCategoriesInner | null
    subcategory: ProductFamilyIconsInner |null
    product: Product | null
    configuration: ConfiguratorProduct | null;
    alternatives: Map<number, SelectedAlternativeProduct>;
    basket: Basket;
    contactData: ContactData;
}

interface ComponentStateToProps extends StateToProps {
    type: ContactType;
    user: UserState|null;
}

interface DispatchToProps {
    submitConfiguration: (type: ContactType) => void
    editConfiguration: () => void
}

const mapStateToProps = (state: ApplicationState): StateToProps => ({
    currency: state.currency,
    category: getSelectedMainCategoryData(state.data),
    subcategory: getSelectedSubCategoryData(state.data),
    product: getSelectedProductData(state.data),
    configuration: state.data.configuration?state.data.configuration.configuration:null,
    alternatives: getSelectedAlternatives(state.data),
    basket: state.basket,
    contactData: state.contactData
});

const mapDispatchToProps = (dispatch: any) : DispatchToProps => ({
    submitConfiguration: (type: ContactType) => dispatch(submitConfiguration(type)),
    editConfiguration: () => dispatch(contactFormReady(false))
});

class _Container extends React.PureComponent<ComponentStateToProps & DispatchToProps & WithTranslation> {

    render() {
        const {configuration, category, subcategory, product, contactData, basket, type, currency, user, t,
            submitConfiguration, editConfiguration} = this.props;
        return <React.Fragment>
            <Container className="py-4 px-0 configuration">
                <Row>
                    <Col className="col-12 col-lg-4 pr-lg-2">
                        {
                            configuration&&category&&subcategory&&product?
                                <StickyBox offsetTop={20} offsetBottom={20}>
                                    <ContactOverviewPage currency={currency} subcategory={subcategory}
                                                              configuration={configuration} product={product} basket={basket} user={user}/>
                                </StickyBox>
                                :null
                        }
                    </Col>
                    <Col className="col-12 col-lg-8 pl-lg-2 pt-3 pt-lg-0">
                        {
                            configuration&&category&&subcategory&&product?
                                <ContactDetailPage category={category} subcategory={subcategory}
                                                   product={product} contactData={contactData} basket={basket} type={type} user={user}/>
                                :null
                        }
                    </Col>
                </Row>
            </Container>
            {
                contactData.formReady ?
                    <Modal isOpen={!contactData.formSubmitted}>
                        <ModalHeader>
                            <div className={"title-normal-uppercase"}>{t('products.configuration.sendtitle' + type)}</div>
                        </ModalHeader>
                        <ModalBody>{t('products.configuration.sendquestion' + type)}</ModalBody>
                        <ModalFooter>
                            <AsyncButton iconClassName={"far fa-edit"} disabled={contactData.formSubmitting} labelTKey={'products.configuration.continueEdit'}
                                         onSubmit={() => editConfiguration()}/>
                            <AsyncButton iconClassName={"far fa-check-circle"} buttonClassName={'primary'}
                                         submitting={contactData.formSubmitting} labelTKey={'products.configuration.sendOk'}
                                         onSubmit={() => submitConfiguration(type)}/>
                        </ModalFooter>
                    </Modal> :
                    null
            }
        </React.Fragment>
    }
}

export const ContactPage = connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(_Container));


// WEBPACK FOOTER //
// ./src/containers/ContactPage.tsx